import { useRef } from "react";

import classNames from "shared/utils/classNames";

import StarterQuestionButton from "./StarterQuestionButton";
import { Props } from "./types";

function PopupMessagesIframe(props: Props) {
  const {
    starterQuestions,
    popupClosedByUser,
    onSuggestionClick,
    isOverButton,
  } = props;

  const rootRef = useRef<HTMLDivElement>(null);

  if (popupClosedByUser || isOverButton) {
    return null;
  }

  return (
    <div
      ref={rootRef}
      className={classNames(starterQuestions.length ? "pb-3" : "pb-0")}
    >
      <div
        className={classNames("popup-messages-container", "justify-end")}
        style={{
          flexDirection: "row",
        }}
      >
        {starterQuestions.map(starterQuestion => (
          <StarterQuestionButton
            key={starterQuestion.id}
            starterQuestion={starterQuestion}
            onSuggestionClick={onSuggestionClick}
            isOverButton={isOverButton}
          />
        ))}
      </div>
    </div>
  );
}

export default PopupMessagesIframe;
